import React, { ReactNode } from 'react';

import { Pressable, Text } from '@rbilabs/universal-components';

import { useReversedUIContext } from 'state/reversed-ui';
import { theme } from 'styles/configure-theme';

export const StyledCtaButton = Pressable.withConfig({
  display: 'flex',
  flexDirection: 'row',
  _web: {
    cursor: 'pointer',
  },
  fontSize: {
    base: 'sm',
    md: 'md',
  },
});

interface CtaButtonProps {
  text?: string;
  cta: () => void;
  icon?: ReactNode;
}

const CtaButton = ({ text, cta, icon }: CtaButtonProps) => {
  const { reversedUI } = useReversedUIContext();

  return (
    <StyledCtaButton onPress={cta} accessibilityRole="button">
      <Text
        color={reversedUI ? theme.token('text-reversed') : theme.token('text-default')}
        pt="3px"
      >
        {text}
      </Text>
      {icon}
    </StyledCtaButton>
  );
};

export default CtaButton;
